import { isShowSavings } from 'common/helpers/featureFlags';
import { currencyFormat } from 'common/helpers/numberHelper';

const CouponsAndPromos = (props) => {
  const { cart, settings } = props;
  const { coupons, promotions } = cart;

  if (coupons.length < 1 && promotions.length < 1) {
    return null;
  }

  return (
    <div className="c7-cart__promo__summary">
      <ul>
        {coupons.map((coupon) => {
          if (coupon.inUse) {
            return (
              <li key={coupon.id}>
                The coupon{' '}
                <span className="c7-discount-title">{coupon.title}</span> has
                been applied.{' '}
                {isShowSavings() && (
                  <span className="c7-discount-amount">
                    Your savings: {currencyFormat(coupon.totalValue, settings)}
                  </span>
                )}
              </li>
            );
          }
          switch (coupon.invalidReason) {
            case 'Not applicable for customer': {
              return (
                <li key={coupon.id}>
                  The coupon{' '}
                  <span className="c7-discount-title">{coupon.title}</span> is
                  not applicable for your customer group.
                </li>
              );
            }
            case 'Order does not meet requirements': {
              return (
                <li key={coupon.id}>
                  Your order does not meet the minimum requirements for coupon{' '}
                  <span className="c7-discount-title">{coupon.title}</span>.
                </li>
              );
            }
            case 'No applicable products in cart': {
              return (
                <li key={coupon.id}>
                  There are no applicable products in your cart for coupon{' '}
                  <span className="c7-discount-title">{coupon.title}</span>.
                </li>
              );
            }
            case 'No applicable shipping in cart': {
              if (cart.shipping.length === 0) {
                return (
                  <li key={coupon.id}>
                    Coupon{' '}
                    <span className="c7-discount-title">{coupon.title}</span>{' '}
                    will not apply until a shipping method is selected.
                  </li>
                );
              }
              return (
                <li key={coupon.id}>
                  Coupon{' '}
                  <span className="c7-discount-title">{coupon.title}</span> is
                  not applicable for the shipping method selected.
                </li>
              );
            }
            case 'Other coupon applicable': {
              return (
                <li key={coupon.id}>
                  Alternate coupon is in use. Coupon{' '}
                  <span className="c7-discount-title">{coupon.title}</span> is
                  not applicable.
                </li>
              );
            }
            default: {
              return (
                <li key={coupon.id}>
                  The coupon{' '}
                  <span className="c7-discount-title">{coupon.title}</span> is
                  not applicable.
                </li>
              );
            }
          }
        })}
        {promotions.map((promo) => (
          <li key={promo.id}>
            <span className="c7-discount-title">{promo.title}</span> is in
            effect.{' '}
            {isShowSavings() && (
              <span className="c7-discount-amount">
                Your savings: {currencyFormat(promo.totalValue, settings)}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CouponsAndPromos;
